PJQ.Pagination = class {
	constructor($el, options = {}) {
		this.$el = $el;
		this.options = _.defaults(options, {
			callback: _.bind(function (items) {
				this.$paginationData.empty();
				_.each(items, function (item) {
					this.renderPageItem(item);
				}, this);
			}, this)
		});
		this.createElement();
		this.render(options.dataSource);
	}

	createElement() {
		//Create inner elements for pagination and data
		if(_.size(this.$el.find('.pagination-controller')) === 0){
			this.$el.append($('<div>', {
				class: 'pagination-controller'
			}));
		}
		if(_.size(this.$el.find('.pagination-data')) === 0){
			this.$el.append($('<div>', {
				class: 'pagination-data mt-2'
			}));
		}

		this.$paginationController = this.$el.find('.pagination-controller');
		this.$paginationData = this.$el.find('.pagination-data');
	}

	render(data) {
		if(data != null){
			this.options.dataSource = data;
		}

		//Instantiate pagination on the pagination controller element
		this.$paginationController.pagination(this.options);
	}

	reload(data){
		this.render(data);
	}

	renderPageItem(item) {
		//If there is an override for rendering each page item, do the callback
		if (typeof this.options.renderPageItem === 'function') {
			this.options.renderPageItem(item);
		}
		//Else if there was a passed in page template, render that, otherwise do nothing
		else if (typeof this.options.pageItemTemplate != null) {
			PJQ.templating.TemplateRenderer.renderTemplate(true, this.options.pageItemTemplate, this.$paginationData, _.extend({
				model: item
			}, this.options.renderData));
		}
	}
};